module.exports = __webpack_public_path__ + "img/list_CommIllustration_02.1edfd609.jpeg";